import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { errorManagerActions } from "@/business/shared/commons/rest/errorManagerActions";

export function restClient() {
  async function retrySendRequest(
    retries: number,
    url: string,
    verb: string,
    body?: any,
    headers?: any,
    signal?: AbortSignal // <-- Nuevo parámetro opcional
  ): Promise<RestResponse> {
    return await sendRequest(url, verb, body, headers, retries, signal);
  }

  async function sendRequest(
    url: string,
    verb: string,
    body?: any,
    headers?: any,
    retries?: number,
    signal?: AbortSignal
  ): Promise<RestResponse> {
    const config = {
      method: verb,
      headers: headers,
      body: body,
      signal,
    };

    console.log("Rest Request", url, config, body);

    const apiResponse: RestResponse = {
      isSuccess: false,
      statusCode: 500,
      content: JSON.stringify(
        errorManagerActions().createError(
          "Error en el servidor, reintente en un momento o contacte con un administrador"
        )
      ),
    };

    const response: Response = await retryableSendRequest(
      retries ?? 1,
      url,
      config
    );

    console.log("Api Response", response);

    if (response.status < 500) {
      apiResponse.isSuccess = response.ok;
      apiResponse.statusCode = response.status;

      const text = await response.text();

      try {
        apiResponse.content = text.length > 0 ? JSON.parse(text) : text;
      } catch (e) {
        console.log(e);
      }
    }

    console.log("Rest Response", apiResponse);

    return apiResponse;
  }

  async function retryableSendRequest(
    retries: number,
    url: string,
    config: any
  ): Promise<Response> {
    let response: Response = new Response();

    while (retries > 0) {
      if (config.signal?.aborted) return response;

      try {
        response = await fetch(url, config);
        if (response.ok) {
          retries = 0;
        } else {
          retries--;
          await sleep(300);
        }
      } catch (error: any) {
        if (error.name === "AbortError") {
          return response;
        }

        if (retries <= 0) {
          throw error;
        }
        retries--;
        await sleep(300);
      }
    }

    return response;
  }

  function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  return {
    sendRequest,
    retrySendRequest,
  };
}
